import { GetProjectResponse, RegisterWorkItemMaterialRequest, RegisterWorkItemOperationRequest, RegisterWorkItemProjectSpecificOperationRequest, WorkItemType } from "api/generatedApi";
import { noMountingCodeSelected } from "components/page/folder/content/measurements/measurements.helpers";
import { formatDateToRequestShortDate } from "utils/formats";
import { DraftWorkItem } from "utils/offline-storage/use-offline-storage";

export interface DraftWorkItemRequest {
  draftId: string;
  text: string;
  workItemType: WorkItemType;
  request: RegisterWorkItemMaterialRequest | RegisterWorkItemOperationRequest | RegisterWorkItemProjectSpecificOperationRequest;
  requestSuccess: boolean;
  requestFailed: boolean;
}
export function UseMapDrafts() {
  const mapToRequests = (project: GetProjectResponse, drafts: DraftWorkItem[]): DraftWorkItemRequest[] => {
    const list: DraftWorkItemRequest[] = [];
    if (!project.id) {
      return [];
    }
    const workItemDate = formatDateToRequestShortDate(new Date());

    drafts.forEach((draft) => {
      const workItemAmount = draft.workItemAmount && draft.workItemAmount > 0 ? draft.workItemAmount : undefined;
      const supplements = draft.supplements;
      const request = {
        draftId: draft.draftId,
        workItemType: draft.workItemType,
        requestFailed: false,
        requestSuccess: false,
      } as DraftWorkItemRequest;
      if (draft.workItemType === "Material") {
        request.text = draft.material?.name ?? "";
        request.request = {
          materialId: draft.material?.id,
          supplementOperations: draft.supplementOperations,
          supplements,
          workItemAmount,
          workItemMountingCode: draft.workItemMountingCode !== noMountingCodeSelected.mountingCode ? draft.workItemMountingCode : undefined,
          workItemDate,
        } as RegisterWorkItemMaterialRequest;
      } else if (draft.workItemType === "Operation") {
        request.text = draft.operation?.operationText ?? "";
        request.request = {
          operationId: draft.operation?.operationId,
          supplements,
          workItemAmount,
          workItemDate,
        } as RegisterWorkItemOperationRequest;
      } else if (draft.workItemType === "ProjectSpecificOperation") {
        request.text = draft.projectSpecificOperation?.projectSpecificOperationText ?? "";
        request.request = {
          projectSpecificOperationId: draft.projectSpecificOperation?.projectSpecificOperationId,
          supplements,
          workItemAmount,
          workItemDate,
        } as RegisterWorkItemProjectSpecificOperationRequest;
      }
      list.push(request);
    });
    return list;
  };

  return { mapToRequests };
}
